import { Alert, Snackbar } from '@mui/material';
import axios, { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authActions } from '../../auth/store/authSlice';

interface ErrorSnackbarState {
  readonly open: boolean;
  readonly errorMessageKey: string;
  readonly backendErrorMessage?: string;
  readonly sysMsg?: string;
}

const GeneralErrorHandler: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [snackbarState, setSnackbarState] = useState<ErrorSnackbarState>({ open: false, errorMessageKey: '' });

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error: AxiosError) => {
        if (error.response?.status === 401) {
          dispatch(authActions.logout({ navigate, isUnauthorized: true }));
        }

        setSnackbarState({
          open: true,
          errorMessageKey: error.message,
          backendErrorMessage: error.response ? (error.response?.data as { msg: string })['msg'] : '*** Missing BE error message ***',
          sysMsg: error.response ? (error.response?.data as { sysMsg: string })['sysMsg'] : '*** Missing BE error message ***',
        });
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  const handleClose = () => {
    setSnackbarState({ open: false, errorMessageKey: '', backendErrorMessage: undefined });
  };

  return (
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState.open}>
      <Alert
        severity="error"
        onClose={handleClose}
        sx={{
          minWidth: '400px',
          maxWidth: '800px',
          alignItems: 'flex-start',
          '& .MuiAlert-message': { maxHeight: '300px', overflowY: 'auto' },
        }}
      >
        {snackbarState.backendErrorMessage || snackbarState.errorMessageKey}
        {snackbarState.sysMsg && (
          <>
            <br />
            {snackbarState.sysMsg}
          </>
        )}
      </Alert>
    </Snackbar>
  );
};

export default GeneralErrorHandler;
